import api from './api';

export const getFormattedRequest = async (id) => {
    try {
        const response = await api.get(`/api/overtime/getFormattedRequest/${id}`);
        return response.data;
    } catch (error) {
        return {};
    }
};